import { render } from "./SongCard.vue?vue&type=template&id=2f5cd0e1&scoped=true"
import script from "./SongCard.vue?vue&type=script&lang=ts"
export * from "./SongCard.vue?vue&type=script&lang=ts"

import "./SongCard.vue?vue&type=style&index=0&id=2f5cd0e1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2f5cd0e1"

export default script